<template lang="html">
  <v-layout row wrap class="filter-content">
    <v-flex
      xs3
      md1
      class="mt-4">
      <span
        class="command-text-1">
        Show me
      </span>
    </v-flex>
    <v-flex
      xs2
      md1
      class="command">
      <v-select
        :items="commands"
        v-model="filter"
        class="command-select"/>
    </v-flex>
    <v-flex
      xs1
      md1
      class="mt-4">
      <span
        class="command-text-2">
        quotes
      </span>
    </v-flex>
    <v-flex
      xs8
      md5
      class="filter-config"
      v-if="filter">
      <v-layout
        row
        wrap>
        <v-flex
          xs2
          md1
          class="mt-4">
          <span
            class="config-text-1">
            with
          </span>
        </v-flex>
        <v-flex
          xs4
          md4>
          <v-select
            :items="filterTypes"
            v-model="filterType"
            class="config-select"/>
        </v-flex>
        <v-flex xs6 md7 v-if="dateFilter">
          <v-layout row wrap>
            <v-flex xs4>
              <v-select
                :items="dateSelectionTypes"
                v-model="dateRange"
                class="config-detail date-type-select"/>
            </v-flex>
            <v-flex xs8>
              <busie-date-picker
                class="filter-input filter-input-date"
                :range="dateRange"
                v-model="filterInput"/>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs7 v-else>
          <v-layout row wrap>
            <v-flex xs4 md3 class="mt-4">
              <span class="config-detail">
                matching
              </span>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                class="filter-input filter-input-text"
                label="Search Value"
                v-model="filterInput"/>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs0 md2>
      <v-btn
        fab
        small
        color="success"
        @click="filterQuotes"
        :disabled="filtering"
        :loading="filtering">
        <v-icon>mdi-check</v-icon>
      </v-btn>
      <v-btn
        fab
        small
        color="error"
        @click="clear">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatePicker from './DatePicker'

export default {
  components: {
    'busie-date-picker': DatePicker
  },
  props: {
    quotes: {
      type: Array,
      required: true,
      default: []
    }
  },
  data: () => ({
    filtering: false,
    filter: false,
    filterType: null,
    filterInput: null,
    dateRange: false,
    commands: [
      { text: 'all', value: false },
      { text: 'only', value: true }
    ],
    filterTypes: [
      { text: 'Pickup Date', value: 'pickup' },
      { text: 'Any Stop Date', value: 'any' },
      { text: 'Organization', value: 'organization' },
      { text: 'Trip Planner', value: 'planner' }
    ],
    dateSelectionTypes: [
      { text: 'on', value: false },
      { text: 'between', value: true }
    ],
    dateFilterTypes: [
      'pickup',
      'any'
    ]
  }),
  computed: {
    dateFilter () {
      return this.dateFilterTypes.includes(this.filterType)
    },
    ...mapGetters('stops',  { allStops: 'all' }),
    ...mapGetters('dates', [ 'byDate' ]),
    ...mapGetters('dispatch', [ 'id' ])
  },
  watch: {
    filter (val) {
      if (!val) {
        this.clear()
      }
    }
  },
  methods: {
    filterQuotes () {
      this.filtering = true
      if (this.dateFilter) {
        return this.filterByDate()
      } else {
        switch (this.filterType) {
          case 'organization':
            this.filterByOrganization()
            break;
          case 'planner':
            this.filterByPlanner()
            break;
          default:
            return
        }
      }
    },
    clear () {
      this.filter = false
      this.filterType = null
      this.filterInput = null
      this.dateRange = false
      this.$emit('clear')
    },
    filterByDate () {
      const qs = `?trip__dispatch=${this.id}`
      return this.fetchAll(qs).then(
        () => {
          this.$emit('filtered', this.quotes.filter(q => this.isStopDate(q)).reverse())
          this.filtering = false
        }
      ).catch(e => {
        this.raiseError(e)
        this.filtering = false
      })
    },
    filterByOrganization () {
      const org = this.filterInput
      this.$emit('filtered', this.quotes.filter(q => q.trip.trip_planner.organization === org))
      this.filtering = false
    },
    filterByPlanner () {
      const planner = this.filterInput
      this.$emit('filtered', this.quotes.filter(q => q.trip.trip_planner.name === planner))
      this.filtering = false
    },
    filterStopsByTrip: (stops, q) => stops.filter(s => s.trip === q.trip.id),
    genTripStopObject: (stops) => ({
      pickup: stops.slice(0, 1).pop(),
      destination: stops.slice(-1).pop(),
      additionalStops: stops.slice(1, -1)
    }),
    isStopDate (quote) {
      const tripStops = this.filterStopsByTrip(this.allStops, quote)
      const trip = this.genTripStopObject(tripStops)
      const filterType = this.filterType
      const dates = this.filterInput.split(' to ').map(ds => new Date(ds))
      const rangeInMS = [ ...dates ].reduceRight((acc, cv) => acc - cv)
      const dayToMS = (24 * 3600 * 1000)
      const rangeInDays = typeof rangeInMS === 'number' ? rangeInMS/dayToMS : 1
      const dateIds = []
      for (let i = 0; i < rangeInDays; i++) {
        let d = new Date(new Date(dates[0]).setDate(dates[0].getDate() + i))
        dateIds.push(this.byDate(d) ? this.byDate(d).id : null);
      }
      if (filterType === 'any') {
        return dateIds.includes(trip.pickup.date) ||
          trip.additionalStops.findIndex(s => dateIds.includes(s.date)) > -1
      } else {
        return dateIds.includes(trip.pickup.date)
      }
    },
    ...mapActions('stops', [ 'fetchAll' ]),
    ...mapActions('app', [ 'raiseError' ])
  }
}
</script>

<style lang="css" scoped>
</style>
